import { useContext } from 'react';
import { useParams } from 'react-router';

import { Box, LinearProgress } from '@mui/material';
import DocumentViewDocumentModal from '../../documents/DocumentViewDocumentModal';
import { DocumentStateContext } from '../../../context/DocumentContext';

import useGetTrainingSet from '../../hooks/useGetTrainingSet';
import { useSetTitle } from '../../hooks/useSetTitle';

import TrainingSetHeader from '../TrainingSetHeader';
import TrainingSetDocumentList from './TrainingSetDocumentList';
import TrainingSetRevisionList from './TrainingSetRevisionList';

const TrainingSetDetails = () => {
  const { dpid, id: tsId } = useParams<{ dpid: string; id: string }>();

  const { openViewDocumentModal } = useContext(DocumentStateContext);

  if (!dpid || !tsId) {
    return null;
  }

  const { data: trainingSet, isError, isLoading } = useGetTrainingSet(tsId);

  useSetTitle(trainingSet?.label ? `Training Set - ${trainingSet?.label}` : '...');

  if (isLoading || !trainingSet) {
    return <LinearProgress />;
  }
  if (!dpid || !tsId) {
    return null;
  }

  return (
    <>
      <Box sx={{ bgcolor: '#F5F6FA', px: '40px', pt: '10px' }}>
        <TrainingSetHeader trainingSet={trainingSet} dpid={dpid} tsid={tsId} />
      </Box>
      <Box sx={{ bgcolor: '#F5F6FA', px: '40px', py: '20px', flex: 1 }}>
        <TrainingSetDocumentList trainingSet={trainingSet} dpid={dpid} />

        <div style={{ marginTop: '40px' }} />
        <TrainingSetRevisionList trainingSetId={trainingSet.id} />
        {openViewDocumentModal ? <DocumentViewDocumentModal /> : null}
      </Box>
    </>
  );
};
export default TrainingSetDetails;
